import { HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

const tableCss = css({
    tableLayout: "fixed",
    width: "100%",
    padding: 0,
    border: 0,
    borderCollapse: "collapse",
    borderSpacing: 0,
    [media.below.sm]: {
        display: "flex",
        flexDirection: "column"
    },
    display: "table"
});

export const GenericTable = (props: HTMLAttributes<HTMLTableElement>) => {
    return <table {...props} css={tableCss} />;
};
